import {
    OrganizationListItem,
    OrganizationListResponse,
} from "@gsx/common/src/types/http/dashboard/organization";
import { Module, RegisterOptions } from "vuex-class-modules";
import ListStoreVuex from "../../../../common/src/stores/general/ListStoreVuex";
import { Api } from "../../../../common/src/api/Api";
import { FilterableListStore } from "../abstracts/CollectionStore";

@Module({ generateMutationSetters: true })
export class UserFavoriteOrganizationListStore
    extends ListStoreVuex<OrganizationListItem>
    implements FilterableListStore<OrganizationListItem>
{
    constructor(private readonly api: Api, options: RegisterOptions) {
        super(options);
    }

    get filteredItems(): OrganizationListItem[] {
        return this.items || [];
    }

    protected async fetch(): Promise<OrganizationListResponse> {
        const orgs = await this.api.launchpad.userFavorites.organization.list();
        const favoriteOrgs = orgs.data;
        return {
            data: favoriteOrgs,
            count: favoriteOrgs.length,
        };
    }
}
